<template>
    <div id="app">
        <primary-header />
        <transition
            :css="false"
            mode="out-in"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave">
            <router-view />
        </transition>
    </div>
</template>

<script>
import { findIndex, kebabCase } from 'lodash';
import PrimaryHeader from '@/components/PrimaryHeader';

export default {
    components: {
        PrimaryHeader
    },
    computed: {
        selections () {
            return this.$store.state.selections;
        }
    },
    watch: {
        '$route.fullPath' (path) {
            this.routeChanged(path);
        }
    },
    created () {
        this.routeChanged(this.$route.fullPath);
    },
    methods: {
        routeChanged (path) {
            const checkedPath = path.indexOf('/detaljer') > -1 ? `${path.split('/detaljer').shift()}/`
                : path.indexOf('/') > 0 ? path.split('/').shift() : path;
            const index = this.selections.map(s => `/${kebabCase(s.type)}/`).indexOf(checkedPath);
            this.$store.commit('setSelectedIndex', index === -1 ? 0 : index);
        },
        beforeEnter (el) {
            el.style.opacity = 0;
            el.style.transform = this.$route.path.indexOf('detaljer') > -1 ? 'translateY(12.5%)' : 'translateY(-12.5%)';
        },
        enter (el, done) {
            this.$anime({
                targets: el,
                opacity: 1,
                translateY: 0,
                duration: 300,
                easing: 'easeOutSine',
                complete: done
            });
        },
        beforeLeave (el) {
            this.freezePos(el);
        },
        leave (el, done) {
            this.$anime({
                targets: el,
                opacity: 0,
                duration: 250,
                translateY: this.$route.path.indexOf('detaljer') > -1 ? '-12.5%' : '12.5%',
                easing: 'easeInSine',
                complete: done
            });
        },
        freezePos (el) {
            const rect = el.getBoundingClientRect();
            el.style.position = 'absolute';
            el.style.top = `${rect.top}px`;
            el.style.left = `${rect.left}px`;
            el.style.width = `${rect.width}px`;
            el.style.height = `${rect.height}px`;
        }
    }
};
</script>
